import { Reducer } from 'redux';
import {
    ORGANIZATION_DELETE_START,
    ORGANIZATION_DELETE_SUCCESS,
    ORGANIZATION_ERROR,
    ORGANIZATION_CLEAR_ERROR,
    ORGANIZATION_CLEAR_SUCCESS,
    ORGANIZATION_FETCH_START,
    ORGANIZATION_FETCH_SUCCESS,
    ORGANIZATION_RESET,
    ORGANIZATION_SAVE_START,
    ORGANIZATION_SAVE_SUCCESS,
    OrganizationAction
} from 'actions/organization/OrganizationActionsTypes';
import { OrganizationState, OrganizationStatus } from './OrganizationState';

const initialState: OrganizationState = {
    organizations: [],
    pagination: {
        currentPage: 1,
        prevPage: null,
        nextPage: null,
        size: 10,
        totalPages: 0,
        totalRecords: 0
    },
    status: OrganizationStatus.Initial,
    loading: false
};

export const organizationsReducer: Reducer<OrganizationState, OrganizationAction> = (state = initialState, action) => {
    switch (action.type) {
        case ORGANIZATION_RESET:
            return {
                ...initialState
            };

        case ORGANIZATION_ERROR:
            return {
                ...state,
                loading: false,
                status: OrganizationStatus.Error,
                error: action.payload.error
            };

        case ORGANIZATION_CLEAR_ERROR:
            return {
                ...state,
                status: OrganizationStatus.Initial,
                error: undefined
            };

        case ORGANIZATION_CLEAR_SUCCESS:
            return {
                ...state,
                status: OrganizationStatus.Initial,
                savedOrganization: undefined
            };

        case ORGANIZATION_FETCH_START:
            return {
                ...state,
                loading: true,
                status: OrganizationStatus.Fetching,
                error: undefined // Clear previous errors
            };

        case ORGANIZATION_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                status: OrganizationStatus.FetchSuccess,
                // Always replace data for pagination (not infinite scroll)
                organizations: action.payload.organizations,
                pagination: action.payload.pagination
            };

        case ORGANIZATION_SAVE_START:
            return {
                ...state,
                loading: true,
                status: OrganizationStatus.Saving,
                savedOrganization: undefined,
                error: undefined // Clear previous errors
            };

        case ORGANIZATION_SAVE_SUCCESS:
            let organizations = [...state.organizations];

            if (organizations.some(org => org.id === action.payload.organization.id)) {
                organizations = organizations.map(org =>
                    org.id === action.payload.organization.id ? { ...action.payload.organization } : org
                );
            } else {
                organizations = [...organizations, { ...action.payload.organization }];
            }

            // Sort by name
            const sortedOrganizations = organizations.sort((a, b) => (a.name || '').localeCompare(b.name || ''));

            return {
                ...state,
                loading: false,
                status: OrganizationStatus.SaveSuccess,
                organizations: sortedOrganizations,
                savedOrganization: { ...action.payload.organization }
            };

        case ORGANIZATION_DELETE_START:
            return {
                ...state,
                loading: true,
                status: OrganizationStatus.Deleting
            };

        case ORGANIZATION_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: OrganizationStatus.DeleteSuccess,
                organizations: state.organizations.filter(org => org.id !== action.payload.organizationId)
            };

        default:
            return state;
    }
};

export default organizationsReducer;
